/* eslint-disable one-var */
/* eslint-disable prefer-const */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/camelcase */
import React, { Component } from 'react';
import Proptypes from 'prop-types';
import NetWorthDonutChart from '../NetWorthDonutChart/NetWorthDonutChartContainer';
import { format_number_as_currency } from './Helpers/BalanceSheetHelpers';
import { Tooltip } from '../CommonComponents/OPL/Tooltip/Tooltip';
import { PDFTitle } from '../PDFRenderer/components/PDFTitle/PDFTitle';
import { Select } from '../CommonComponents/OPL/Select/Select/Select';
import { Box } from '../CommonComponents/OPL/Box/Box';

class BalanceSheetView extends Component {
  constructor(props) {
    super(props);
    const { fetch_data, clientId } = this.props;
    fetch_data(null, clientId);

    this.state = {
      breakdown: {},
      expanded_rows: [],
    };
  }

  componentWillUnmount() {
    const { is_projected } = this.props;
    if (is_projected) this.setProjected();
  }

  setExpanded(owner, group_name, self) {
    const { expanded_rows } = self.state;
    let local_rows = expanded_rows.slice(),
      row_index = expanded_rows.indexOf(`${owner}|${group_name}`);

    if (row_index > -1) {
      local_rows.splice(row_index, 1);
    } else {
      local_rows.push(`${owner}|${group_name}`);
    }

    this.setState({
      expanded_rows: local_rows,
    });
  }

  handleOwnerChange(owners) {
    const { fetch_data, clientId } = this.props;
    let localowners = owners.map(owner => owner.value);
    this.setState({
      owners: localowners,
    });
    fetch_data(localowners, clientId);
  }

  show_breakdown(e, breakdown) {
    let target = e.target,
      bounding_rect = target.getBoundingClientRect(),
      shown = false;

    for (let key in breakdown) if (breakdown[key] != null) shown = true;

    if (shown) target.classList.add('highlight');

    this.setState({
      ...breakdown,
      show_breakdown: true,
      breakdown_top: bounding_rect.top,
      breakdown_left: bounding_rect.left,
      breakdown_width: bounding_rect.width,
      breakdown_height: bounding_rect.height,
    });
  }

  hide_breakdown(e) {
    let target = e.target;

    target.classList.remove('highlight');

    this.setState({
      show_breakdown: false,
      earnings: null,
      contributions: null,
      distributions: null,
      payment: null,
      interest: null,
    });
  }

  render() {
    const {
        is_initialized,
        BalanceSheet,
        OwnerOptions,
        owners: baseOwners,
        clientId,
        isPrint,
        title,
      } = this.props,
      { expanded_rows } = this.state;
    let owner_info = {},
      asset_groups = [],
      liability_groups = [],
      year = new Date().getFullYear();

    if (is_initialized) {
      baseOwners.forEach(owner => {
        owner_info[owner] = BalanceSheet.find(bs => bs.Owner === owner);
      });
      owner_info.Total = BalanceSheet.find(bs => bs.Owner === 'Total');
      if (!!owner_info.Total && !!owner_info.Total.Assets.AssetGroups.length) {
        asset_groups = owner_info.Total.Assets.AssetGroups.slice();
      }
      if (!!owner_info.Total && !!owner_info.Total.Liabilities.LiabilityGroups.length) {
        liability_groups = owner_info.Total.Liabilities.LiabilityGroups.slice();
      }

      const MAX_COLUMNS_PER_PAGE = 5;
      const data = isPrint
        ? baseOwners.reduce((ownersGroup, owner, index) => {
            const listNumber = Math.floor(index / MAX_COLUMNS_PER_PAGE);
            return {
              ...ownersGroup,
              [listNumber]: [...(ownersGroup[listNumber] ? ownersGroup[listNumber] : []), owner],
            };
          }, {})
        : { baseOwners };

      const ownerOptions = OwnerOptions.map(owner => ({ label: owner, value: owner }));
      const ownerSelected = baseOwners.map(owner => ({ label: owner, value: owner }));

      return (
        <div id="NetWorthBalancesheetReport" className="BalanceSheet">
          <PDFTitle title={title} />

          {!isPrint && (
            <div className="table-controls">
              <Box width="250px">
                <Select
                  isMulti
                  label="Owners"
                  value={ownerSelected}
                  options={ownerOptions}
                  onChange={opt => {
                    this.handleOwnerChange(opt);
                  }}
                  variant="checkbox"
                />
              </Box>
            </div>
          )}
          {!isPrint && (
            <div className="charts">
              <NetWorthDonutChart type="Assets" clientId={clientId} />
              <NetWorthDonutChart type="Liabilities" clientId={clientId} />
            </div>
          )}

          {Object.values(data).map((owners, index) => {
            const isLastColumn = index === Object.values(data).length - 1;

            return (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                className={`balance-sheet-group${isLastColumn ? '' : ' page-break'}`}
              >
                <section className={`year-table widgetize${isPrint ? ' is-print' : ''}`}>
                  <div className="inner-container">
                    <ul
                      className={`table unfixed${
                        isPrint
                          ? baseOwners.length >= MAX_COLUMNS_PER_PAGE
                            ? ' many-columns is-print'
                            : ' is-print'
                          : ''
                      }`}
                    >
                      <li className="thead">
                        <ul>
                          <li className="fixed" />
                          <li className="fixed-shadow" />
                          {/* Ghost the absolutely positioned cells */}
                          {!!owners.length &&
                            owners.map(owner => (
                              <li key={owner}>
                                <span>{owner}</span>
                              </li>
                            ))}
                          {isLastColumn && (
                            <li className="last-column">
                              <span>Total</span>
                            </li>
                          )}
                        </ul>
                      </li>
                      <li className="tbody">
                        <ul className="subheader">
                          <li className="fixed">
                            <strong>Assets</strong>
                          </li>
                          <li className="fixed-shadow" />
                          {/* Ghost the absolutely positioned cells */}
                          {!!owners.length &&
                            owners.map(owner => (
                              <li
                                key={owner}
                                className="has-breakdown"
                                onMouseEnter={e => {
                                  if (!owner_info[owner]) {
                                    this.show_breakdown(e, {
                                      earnings: owner_info[owner].Assets.AssetsInvestmentEarnings,
                                      contributions: owner_info[owner].Assets.AssetsContributions,
                                      distributions: owner_info[owner].Assets.AssetsDistributions,
                                    });
                                  }
                                }}
                                onMouseLeave={e => this.hide_breakdown(e)}
                              >
                                <span>
                                  {format_number_as_currency(
                                    owner_info[owner].Assets.AssetsBalance,
                                  )}
                                </span>
                              </li>
                            ))}

                          {isLastColumn && (
                            <li
                              className="last-column"
                              onMouseEnter={e =>
                                this.show_breakdown(e, {
                                  earnings: owner_info.Total.Assets.AssetsInvestmentEarnings,
                                  contributions: owner_info.Total.Assets.AssetsContributions,
                                  distributions: owner_info.Total.Assets.AssetsDistributions,
                                })
                              }
                              onMouseLeave={e => this.hide_breakdown(e)}
                            >
                              <span>
                                {format_number_as_currency(owner_info.Total.Assets.AssetsBalance)}
                              </span>
                            </li>
                          )}
                        </ul>
                        {!!asset_groups.length &&
                          asset_groups.map((asset, i) => {
                            const total_asset_group = owner_info.Total.Assets.AssetGroups.find(
                              x => x.AssetGroup === asset.AssetGroup,
                            );
                            const expanded = expanded_rows.includes(`${year}|${asset.AssetGroup}`);
                            const retElements = [
                              <ul key={i} className={`base_row${i % 2 === 0 ? ' even' : ''}`}>
                                <li
                                  className="fixed"
                                  onClick={() => this.setExpanded(year, asset.AssetGroup, this)}
                                >
                                  {!isPrint && (
                                    <i
                                      className={`fa ${expanded ? 'fa-minus' : 'fa-plus'} expando`}
                                    />
                                  )}
                                  {asset.AssetGroup}
                                </li>
                                <li />
                                {/* Ghost the absolutely positioned cells */}
                                {!!owners.length &&
                                  owners.map(owner => {
                                    const asset_group = owner_info[owner].Assets.AssetGroups.find(
                                      x => x.AssetGroup === asset.AssetGroup,
                                    );
                                    return (
                                      <li
                                        key={owner}
                                        className="has-breakdown"
                                        onMouseEnter={e => {
                                          if (!!asset_group) {
                                            this.show_breakdown(e, {
                                              earnings: asset_group.AssetGroupInvestmentEarnings,
                                              contributions: asset_group.AssetGroupContributions,
                                              distributions: asset_group.AssetGroupDistributions,
                                            });
                                          }
                                        }}
                                        onMouseLeave={e => this.hide_breakdown(e)}
                                      >
                                        <span>
                                          {!!asset_group
                                            ? format_number_as_currency(
                                                asset_group.AssetGroupBalance,
                                              )
                                            : format_number_as_currency(0)}
                                        </span>
                                      </li>
                                    );
                                  })}
                                {isLastColumn && (
                                  <li
                                    className="last-column"
                                    onMouseEnter={e => {
                                      if (!!asset) {
                                        this.show_breakdown(e, {
                                          earnings: asset.AssetGroupInvestmentEarnings,
                                          contributions: asset.AssetGroupContributions,
                                          distributions: asset.AssetGroupDistributions,
                                        });
                                      }
                                    }}
                                    onMouseLeave={e => this.hide_breakdown(e)}
                                  >
                                    <span>
                                      {format_number_as_currency(asset.AssetGroupBalance)}
                                    </span>
                                  </li>
                                )}
                              </ul>,
                            ];
                            if ((isPrint || expanded) && !!asset.AssetDetails.length) {
                              asset.AssetDetails.forEach((detail, n) => {
                                // children
                                const local_detail = total_asset_group.AssetDetails.find(
                                  x => x.Id === detail.Id,
                                );
                                retElements.push(
                                  <ul
                                    className={`detail${i % 2 === 0 ? ' even' : ''}${
                                      n === asset.AssetDetails.length - 1 ? ' last-row' : ''
                                    }`}
                                  >
                                    <li className="fixed indented">
                                      <Tooltip
                                        content={detail.Name}
                                        placement="top-start"
                                        offset={[50, -8]}
                                      >
                                        <span>{detail.Name}</span>
                                      </Tooltip>
                                    </li>
                                    <li />
                                    {/* Ghost the absolutely positioned cells */}
                                    {!!owners.length &&
                                      owners.map(owner => {
                                        let owner_group = owner_info[owner].Assets.AssetGroups.find(
                                            x => x.AssetGroup === asset.AssetGroup,
                                          ),
                                          owner_detail = owner_group
                                            ? owner_group.AssetDetails.find(x => x.Id === detail.Id)
                                            : {
                                                InvestmentEarnings: null,
                                                Contributions: null,
                                                Distributions: null,
                                              };
                                        return (
                                          <li
                                            key={owner}
                                            className="has-breakdown"
                                            onMouseEnter={e => {
                                              if (!!owner_detail) {
                                                this.show_breakdown(e, {
                                                  earnings: owner_detail.InvestmentEarnings,
                                                  contributions: owner_detail.Contributions,
                                                  distributions: owner_detail.Distributions,
                                                });
                                              }
                                            }}
                                            onMouseLeave={e => this.hide_breakdown(e)}
                                          >
                                            <span>
                                              {!!owner_detail
                                                ? format_number_as_currency(owner_detail.Balance)
                                                : format_number_as_currency(0)}
                                            </span>
                                          </li>
                                        );
                                      })}
                                    {isLastColumn && (
                                      <li
                                        className="last-column"
                                        onMouseEnter={e => {
                                          if (!!detail) {
                                            this.show_breakdown(e, {
                                              earnings: local_detail.InvestmentEarnings,
                                              contributions: local_detail.Contributions,
                                              distributions: local_detail.Distributions,
                                            });
                                          }
                                        }}
                                        onMouseLeave={e => this.hide_breakdown(e)}
                                      >
                                        <span>
                                          {format_number_as_currency(local_detail.Balance)}
                                        </span>
                                      </li>
                                    )}
                                  </ul>,
                                );
                              });
                            }
                            return retElements;
                          })}
                        <ul className="subheader">
                          <li className="fixed">
                            <strong>Liabilities</strong>
                          </li>
                          <li className="fixed-shadow" />
                          {/* Ghost the absolutely positioned cells */}
                          {!!owners.length &&
                            owners.map(owner => (
                              <li
                                key={owner}
                                className="has-breakdown"
                                onMouseEnter={e => {
                                  if (!!owner_info[owner]) {
                                    this.show_breakdown(e, {
                                      earnings: owner_info[owner].Assets.AssetsInvestmentEarnings,
                                      contributions: owner_info[owner].Assets.AssetsContributions,
                                      distributions: owner_info[owner].Assets.AssetsDistributions,
                                    });
                                  }
                                }}
                                onMouseLeave={e => this.hide_breakdown(e)}
                              >
                                <span>
                                  {format_number_as_currency(
                                    owner_info[owner].Liabilities.LiabilitiesBalance,
                                  )}
                                </span>
                              </li>
                            ))}
                          {isLastColumn && (
                            <li
                              className="last-column"
                              onMouseEnter={e => {
                                if (!!owner_info.Total) {
                                  this.show_breakdown(e, {
                                    earnings: owner_info.Total.Assets.AssetsInvestmentEarnings,
                                    contributions: owner_info.Total.Assets.AssetsContributions,
                                    distributions: owner_info.Total.Assets.AssetsDistributions,
                                  });
                                }
                              }}
                              onMouseLeave={e => this.hide_breakdown(e)}
                            >
                              <span>
                                {format_number_as_currency(
                                  owner_info.Total.Liabilities.LiabilitiesBalance,
                                )}
                              </span>
                            </li>
                          )}
                        </ul>
                        {!!liability_groups.length &&
                          liability_groups.map((liability, i) => {
                            const total_liability_group = owner_info.Total.Liabilities.LiabilityGroups.find(
                              x => x.LiabilityGroup === liability.LiabilityGroup,
                            );
                            let expanded = expanded_rows.includes(
                                `${year}|${liability.LiabilityGroup}`,
                              ),
                              ret_elements = [
                                <ul className={`base_row${i % 2 === 0 ? ' even' : ''}`}>
                                  <li
                                    className="fixed"
                                    onClick={() =>
                                      this.setExpanded(year, liability.LiabilityGroup, this)
                                    }
                                  >
                                    {!isPrint && (
                                      <i
                                        className={`fa ${
                                          expanded ? 'fa-minus' : 'fa-plus'
                                        } expando`}
                                      />
                                    )}
                                    {liability.LiabilityGroup}
                                  </li>
                                  <li />
                                  {/* Ghost the absolutely positioned cells */}
                                  {!!owners.length &&
                                    owners.map(owner => {
                                      const liability_group = owner_info[
                                        owner
                                      ].Liabilities.LiabilityGroups.find(
                                        x => x.LiabilityGroup === liability.LiabilityGroup,
                                      );
                                      return (
                                        <li
                                          key={owner}
                                          className="has-breakdown"
                                          onMouseEnter={e => {
                                            if (!!liability_group) {
                                              this.show_breakdown(e, {
                                                payment: liability_group.LiabilityGroupPayment,
                                                interest: liability_group.LiabilityGroupInterest,
                                              });
                                            }
                                          }}
                                          onMouseLeave={e => this.hide_breakdown(e)}
                                        >
                                          <span>
                                            {!!liability_group
                                              ? format_number_as_currency(
                                                  liability_group.LiabilityGroupBalance,
                                                )
                                              : format_number_as_currency(0)}
                                          </span>
                                        </li>
                                      );
                                    })}
                                  {isLastColumn && (
                                    <li
                                      className="last-column"
                                      onMouseEnter={e => {
                                        if (!!total_liability_group) {
                                          this.show_breakdown(e, {
                                            payment: total_liability_group.LiabilityGroupPayment,
                                            interest: total_liability_group.LiabilityGroupInterest,
                                          });
                                        }
                                      }}
                                      onMouseLeave={e => this.hide_breakdown(e)}
                                    >
                                      <span>
                                        {format_number_as_currency(
                                          total_liability_group.LiabilityGroupBalance,
                                        )}
                                      </span>
                                    </li>
                                  )}
                                </ul>,
                              ];
                            if ((isPrint || expanded) && !!liability.LiabilityDetails.length) {
                              liability.LiabilityDetails.forEach((detail, n) => {
                                ret_elements.push(
                                  <ul
                                    className={`detail${i % 2 === 0 ? ' even' : ''}${
                                      n === liability.LiabilityDetails.length - 1 ? ' last-row' : ''
                                    }`}
                                  >
                                    <li className="fixed indented">
                                      <span>{detail.Name}</span>
                                    </li>
                                    <li />
                                    {/* Ghost the absolutely positioned cells */}
                                    {!!owners.length &&
                                      owners.map(owner => {
                                        let owner_group = owner_info[
                                            owner
                                          ].Liabilities.LiabilityGroups.find(
                                            x => x.LiabilityGroup === liability.LiabilityGroup,
                                          ),
                                          owner_detail = owner_group
                                            ? owner_group.LiabilityDetails.find(
                                                x => x.Id === detail.Id,
                                              )
                                            : {
                                                Interest: null,
                                                Payment: null,
                                              };
                                        return (
                                          <li
                                            key={owner}
                                            className="has-breakdown"
                                            onMouseEnter={e => {
                                              if (!!detail) {
                                                this.show_breakdown(e, {
                                                  interest: owner_detail.Interest,
                                                  payment: owner_detail.Payment,
                                                });
                                              }
                                            }}
                                            onMouseLeave={e => this.hide_breakdown(e)}
                                          >
                                            <span>
                                              {!!owner_detail
                                                ? format_number_as_currency(owner_detail.Balance)
                                                : format_number_as_currency(0)}
                                            </span>
                                          </li>
                                        );
                                      })}
                                    {isLastColumn && (
                                      <li
                                        className="last-column"
                                        onMouseEnter={e => {
                                          if (!!detail) {
                                            this.show_breakdown(e, {
                                              interest: detail.Interest,
                                              payment: detail.Payment,
                                            });
                                          }
                                        }}
                                        onMouseLeave={e => this.hide_breakdown(e)}
                                      >
                                        <span>{format_number_as_currency(detail.Balance)}</span>
                                      </li>
                                    )}
                                  </ul>,
                                );
                              });
                            }
                            return ret_elements;
                          })}
                        <ul className="networth">
                          <li className="fixed">
                            <strong>Net Worth</strong>
                          </li>
                          <li className="fixed-shadow" />
                          {/* Ghost the absolutely positioned cells */}
                          {!!owners.length &&
                            owners.map(owner => {
                              const lessThanZero = owner_info[owner].Networth < 0;
                              const number = format_number_as_currency(
                                Math.abs(owner_info[owner].Networth),
                              );
                              return (
                                <li key={owner}>
                                  <span className={lessThanZero ? 'red' : null}>{number}</span>
                                </li>
                              );
                            })}
                          {isLastColumn && (
                            <li className="last-column">
                              <span className={owner_info.Total.Networth < 0 ? 'red' : null}>
                                {format_number_as_currency(Math.abs(owner_info.Total.Networth))}
                              </span>
                            </li>
                          )}
                        </ul>
                      </li>
                    </ul>
                  </div>
                </section>
              </div>
            );
          })}

          {!isPrint &&
            !!this.state.show_breakdown &&
            (this.state.earnings != null ||
              this.state.contributions != null ||
              this.state.distributions != null ||
              this.state.payment != null ||
              this.state.interest != null) && (
              <div
                className="breakdown"
                style={{
                  bottom: window.innerHeight - this.state.breakdown_top + 10,
                  left: this.state.breakdown_left + this.state.breakdown_width / 2,
                }}
              >
                <table>
                  {this.state.earnings != null && (
                    <tr>
                      <td className="bold">Earnings</td>
                      <td>{format_number_as_currency(this.state.earnings)}</td>
                    </tr>
                  )}
                  {this.state.contributions != null && (
                    <tr>
                      <td className="bold">Contributions</td>
                      <td>{format_number_as_currency(this.state.contributions)}</td>
                    </tr>
                  )}
                  {this.state.distributions != null && (
                    <tr>
                      <td className="bold">Distributions</td>
                      <td>{format_number_as_currency(this.state.distributions, 0)}</td>
                    </tr>
                  )}
                  {this.state.payment != null && (
                    <tr>
                      <td className="bold">Payments</td>
                      <td>{format_number_as_currency(this.state.payment)}</td>
                    </tr>
                  )}
                  {this.state.interest != null && (
                    <tr>
                      <td className="bold">Interest</td>
                      <td>{format_number_as_currency(this.state.interest)}</td>
                    </tr>
                  )}
                </table>
              </div>
            )}
        </div>
      );
    }

    return null;
  }
}

BalanceSheetView.defaultProps = {
  title: 'Net Worth: Detailed',
};

BalanceSheetView.propTypes = {
  owners: Proptypes.arrayOf(Proptypes.string).isRequired,
  title: Proptypes.string,
};

export default BalanceSheetView;
